import { connect } from 'react-redux';
import { compose } from 'redux';
import { withStyles } from '@material-ui/core';
import { withRouter } from 'react-router-dom';
import { withConfig } from 'modules/shell/hoc/withConfig';
import _get from 'lodash/get';
import AuditUserOptions from './AuditUserOptions';
import { retrieveDailyTotalsReport, retrieveDailyReceiptReport, getOrderLists } from '../../actions/auditUserActions';
import styles from './AuditUserOptions.styles';

const mapStateToProps = (state) => {
  const {
    user: { data },
    generalManagerStores: { selectedStore },
    auditUserOptions: { links, loading, error },
  } = state;

  return {
    selectedStoreId: _get(selectedStore, [data?.brand, 'storeId'], null),
    linksData: links,
    loading,
    error,
  };
};

const mapDispatchToProps = {
  getOrderLists,
  retrieveDailyTotalsReport,
  retrieveDailyReceiptReport,
};

export default compose(
  withStyles(styles),
  withConfig(),
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
)(AuditUserOptions);
